<button
  mat-flat-button
  [color]="color()"
  [disabled]="loading() || disabled()"
  [class]="className()"
  (click)="onClick()"
>
  @if (loading()) {
    <mat-spinner diameter="20" class="me-2"></mat-spinner>
  } @else if (icon()) {
    <mat-icon class="me-2">{{ icon() }}</mat-icon>
  }
  {{ label() }}
</button>
